/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Pause_Reasons_Create_OrderInputs */

const en_forms_pause_reasons_create_order = /** @type {(inputs: Forms_Pause_Reasons_Create_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order`)
};

const de_forms_pause_reasons_create_order = /** @type {(inputs: Forms_Pause_Reasons_Create_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reihenfolge`)
};

/**
* | output |
* | --- |
* | "Order" |
*
* @param {Forms_Pause_Reasons_Create_OrderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_pause_reasons_create_order = /** @type {((inputs?: Forms_Pause_Reasons_Create_OrderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Pause_Reasons_Create_OrderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_pause_reasons_create_order(inputs)
	return de_forms_pause_reasons_create_order(inputs)
});